import React from 'react'
import { Field, ErrorMessage } from 'formik';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CustomGstDropdown from './CustomGstDropdown';
import ReactQuill from "react-quill";
import Skeleton from "@mui/material/Skeleton"
import ReactHtmlParser from "react-html-parser";
import { handleFileUploadClick, handleFileUpload, handleDeleteSelectedFile, handleCloseFileSizeError } from "./fileUploadHelpers";
import RfqInformation from './RfqInformation';
import { shouldShowVendorRank } from "./utils/rankVisibility";

const MobileSectionCard = ({ number, title, description, children }) => (
    <section className="rounded-2xl border border-[#E6E6DD] bg-white shadow-sm overflow-hidden">
        <div className="flex gap-3 border-b border-[#EFEFE8] bg-[#FBFBF7] px-4 py-4">
            <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#ff6700] text-xs font-semibold text-white">
                {number}
            </div>
            <div>
                <h3 className="text-base font-semibold text-[#2F2F22]">{title}</h3>
                {description && <p className="mt-1 text-xs leading-5 text-[#7A7A68]">{description}</p>}
            </div>
        </div>
        <div className="p-4">
            {children}
        </div>
    </section>
);

const isCounterOfferSelected = (value) => value === false || value === "false";



const MaterialMobileQuotatoinForm = ({ values, setFieldValue,
    selectedMaterials,
    handleAvailabilityCheckboxChange,
    openAccordian,
    toggleAccordion,
    handleDownloadMaterialExcel,
    handleUploadMaterialExcel,
    rfqData,
    toggleExpanded,
    expandedStates,
    isSpecsPopupOpen,
    togglePopupSpecs,
    handleFieldChange,
    overallTotal,
    overallTotalExclGST,
    totalMaterialCostsExclGST,
    currentRank,
    setSelectedMaterialIndex,
    setOpenUploadFile,
    isReadOnly,
    totalCosts,
    visibleMiscellaneousItems,
    handleMiscellaneousChange,
    handleGstChange,
    attachmentsData,
    togglePopup,
    isPopupOpen,
    setIsCounterTerm,
    isCounterTerm,
    attachmentsSkeleton,
    selectedFilesBase,
    attachmentsUploadsErrors,
    openFilesSizeError,
    selectedFilesTotalSize,
    setAttachmentsSkeleton,
    setSelectedFilesBase,
    setSelectedFilesTotalSize,
    setOpenFilesSizeError,
    setAttachmentsUploadsErrors,
    isAdvancedTransport
}) => {
    const totalMaterialValueExclGst = values.materials.reduce(
        (sum, material) => sum + (Number(material.totalExclGst) || 0),
        0
    );
    return (
        <div className="block lg:hidden h-screen flex-grow overflow-auto bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF]">
            <div className="h-auto flex-grow overflow-y-auto pb-24">
                <div className="relative step-content">
                    <div>
                        {/* rfq information */}
                        <div className="">
                            <div className="px-4 pt-4 lg:hidden">
                                {/* <h3 className="text-xl font-semibold text-[#3B3B3B]">{rfqData?.name}</h3> */}
                                {/* <h3 className="font-semibold text-[#3B3B3B]"><span className="text-[#787878]">Requirement Name:</span> {rfqData?.name}</h3> */}
                                {/* <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Bookmark.svg" alt="save" className="self-start" /> */}

                                {/* <p className="font-normal text-[#787878] lg:hidden">Create Date: {new Date(rfqData?.createdAt).toLocaleDateString('en-GB')}</p> */}
                                {/* <p className="text-sm font-medium text-[#787878] mt-2 lg:hidden">RFQ Information</p> */}
                            <RfqInformation
                                rfqData={rfqData}
                                togglePopup={togglePopup}
                                isPopupOpen={isPopupOpen}
                                isAccordion
                            />
                            </div>
                        </div>
                        {false && shouldShowVendorRank(rfqData) && (
                            <div className="mx-4 mt-3 rounded-2xl border border-[#DDEFD9] bg-white p-3 shadow-sm flex items-center justify-center">
                                <div className="flex items-center space-x-2">
                                    <span className="relative flex items-center justify-center h-4 w-4 ">
                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-lime-500 opacity-40"></span>
                                        <span className="relative inline-flex rounded-full h-2 w-2 bg-lime-500"></span>
                                    </span>
                                    <h3 className="text-sm lg:mt-1 text-center text-[#737373]">
                                        Quotation Rank:{" "}
                                        <span className="font-bold text-black">
                                            {currentRank === "L1"
                                                ? "L2"
                                                : currentRank === undefined || currentRank === null
                                                    ? "Quotation not submitted"
                                                    : currentRank}
                                        </span>
                                    </h3>
                                    {/* <p className="text-[#9F9F9F] lg:mt-1 text-xs italic hidden lg:block">Your rank will update as soon as the buyer receives atleast 3 ratings</p> */}
                                </div>
                            </div>
                        )}

                        {/* {
                                <div className="flex flex-col items-end m-6">
                                    <div className="flex space-x-4">
                                        <button
                                            type="button"
                                            onClick={handleDownloadMaterialExcel}
                                            className="bg-blue-500 text-white px-3 py-1.5 text-xs"
                                        >
                                            Download Requirement
                                        </button>

                                        <label className="border border-gray-800 px-3 py-1.5 cursor-pointer text-xs">
                                            Upload Rates
                                            <input
                                                type="file"
                                                accept=".xlsx"
                                                onChange={(e) => handleUploadMaterialExcel(e, setFieldValue, values)}
                                                className="hidden"
                                            />
                                        </label>
                                    </div>
                                    <p className="text-xs text-gray-500 mt-2">Note: Download requirement for uploading material list</p>
                                </div>
                            } */}
                    </div>
                    <div className="px-4 py-5 space-y-5">
                        <MobileSectionCard
                            number="1"
                            title={`Material List (${rfqData?.materials?.length || 0})`}
                            description="Open each item to submit rates."
                        >
                            <div className="space-y-3">
                                {rfqData?.materials?.map((row, index) => (
                                    <div key={index} className="rounded-xl border border-[#E7E7DD] bg-white overflow-hidden">
                                        {/* Mobile Accordion Header */}
                                        <div className={`block lg:hidden px-4 py-3 cursor-pointer ${openAccordian === index ? 'bg-[#F8FAFF]' : 'bg-white'}`} onClick={() => toggleAccordion(index)}>
                                            <div className="flex justify-between items-center">
                                                <div className="flex min-w-0 items-center space-x-3">
                                                    <div className="w-[28px] h-[28px] shrink-0 bg-[#EFEFEB] rounded-full flex justify-center items-center">
                                                        <p className="text-xs font-semibold text-[#6A6A6A]">{index + 1}</p>
                                                    </div>
                                                    <div className="flex min-w-0 items-start gap-x-2 col-span-3 py-1 text-xs whitespace-pre-line">
                                                        {/* <input
                                                                    type="checkbox"
                                                                    checked={selectedMaterials.includes(row.id)}
                                                                    // onChange={() => handleCheckboxChange(row.id)}
                                                                    className="w-3 h-3 my-auto"
                                                                /> */}
                                                        <h2 className="text-sm font-semibold leading-5 text-[#303026]">{ReactHtmlParser(row?.name)}</h2>
                                                    </div>
                                                </div>
                                                <div className="flex shrink-0 justify-end space-x-4">
                                                    {/* <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/tick_vendor_quotation.svg" alt="tick" /> */}
                                                    <img
                                                        src="https://storagereponeevaydevcdn.blob.core.windows.net/business/dropdown_arrow.svg"
                                                        alt=""
                                                        className={`ml-2 transition-transform ${openAccordian === index ? 'rotate-180' : ''}`}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Accordion Content */}
                                        {openAccordian === index && (
                                            <div className="space-y-4 border-t border-[#E7E7DD] bg-[#FCFCFA] py-4 px-4">

                                                {/* quantity */}
                                                {row?.brands.length > 0 && <div className="self-end">
                                                    <label htmlFor="" className="text-sm pb-2 font-semibold lg:hidden">Brand</label>
                                                    <p className="text-sm col-span-1">{row?.brands.join(", ")}</p>
                                                </div>}

                                                {/* quantity */}
                                                <div className="self-end">
                                                    <label htmlFor="" className="text-sm pb-2 font-semibold lg:hidden">Quantity</label>
                                                    <p className="text-sm col-span-1">{row.quantity} {row.unit}</p>
                                                </div>

                                                {/* specifications */}
                                                {row?.specifications?.length > 0 && <div className="self-end col-span-2">
                                                    <label htmlFor="" className="text-sm font-semibold pb-2 lg:hidden">Specifications</label>
                                                    <div className="col-span-6 min-h-fit">
                                                        {row?.specifications?.length > 0 && (
                                                            <div className="col-span-4 text-xs">
                                                                <p className="font-light whitespace-pre-line">
                                                                    {ReactHtmlParser(
                                                                        expandedStates[index]
                                                                            ? row?.specifications
                                                                            : row?.specifications?.substring(0, 160) +
                                                                            (row?.specifications?.length > 160
                                                                                ? "..."
                                                                                : "")
                                                                    )}
                                                                </p>
                                                                {row?.specifications?.length > 160 && (
                                                                    <button
                                                                        type="button"
                                                                        className="text-[#8E8E85] text-xs underline italic"
                                                                        onClick={() => toggleExpanded(index)}
                                                                    >
                                                                        {expandedStates[index] ? "Read Less" : "Read More"}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>}

                                                <div className='flex items-center space-x-2'>
                                                    <label className="font-semibold text-sm flex items-center relative">
                                                        Availability :
                                                    </label>
                                                    <input
                                                        type="checkbox"
                                                        checked={values.materials[index].isAvailable}
                                                        onChange={(e) => handleAvailabilityCheckboxChange(
                                                            index,
                                                            values.materials[index].isAvailable,
                                                            values,
                                                            setFieldValue
                                                        )}
                                                        className="w-3 h-3 focus:ring-0 disabled:cursor-not-allowed"
                                                        disabled={isReadOnly}
                                                    />
                                                </div>

                                                {/* mrp */}
                                                <div className="col-span-2 flex flex-col">
                                                    <label className="font-semibold text-sm pb-2 col-span-2 flex items-center relative">
                                                        MRP Per Unit
                                                        <span className="bg-[#cac9c9] text-white text-xs h-[15px] w-[15px] flex justify-center items-center mb-1 ml-1 pt-1 rounded-full lowercase relative group hover:cursor-pointer">
                                                            i
                                                            <span className="absolute bottom-[130%] text-xs left-1/2 w-[200px] z-10 transform -translate-x-1/2 px-2 py-1 text-[#434343] text-left bg-white border border-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                                                Enter the cost per unit for the selected construction material. Ensure accuracy as this value impacts overall project budgeting and pricing.
                                                            </span>
                                                        </span>
                                                    </label>

                                                    <Field
                                                        name={`materials[${index}].basePrice`}
                                                        type="text"
                                                        className={`w-full rounded-lg text-sm h-[42px] border-[#DCDCD0] border px-3 py-2 ${(!values.materials[index].isAvailable || isReadOnly) ? "bg-gray-100" : "bg-white"}`}
                                                        onChange={(e) => handleFieldChange(index, 'basePrice', e.target.value, values, setFieldValue)}
                                                        disabled={!values.materials[index].isAvailable || isReadOnly}
                                                    />
                                                    <ErrorMessage name={`materials[${index}].basePrice`} component="div" className="text-red-500 text-sm" />
                                                </div>
                                                <div className="grid grid-cols-2 gap-4 items-start">
                                                    {/* discount */}
                                                    <div className="self-start flex flex-col">
                                                        <label className="font-semibold text-sm pb-1 col-span-2 flex items-center relative">
                                                            Discount (%)
                                                            <span className="bg-[#cac9c9] text-white text-xs h-[15px] w-[15px] flex justify-center items-center mb-1 ml-1 pt-1 rounded-full lowercase relative group hover:cursor-pointer">
                                                                i
                                                                <span className="absolute bottom-[130%] text-xs left-1/2 w-[200px] z-10 transform -translate-x-1/2 px-2 py-1 text-[#434343] text-left bg-white border border-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                                                    Specify the discount percentage or amount offered on this material. This discount will be applied to the unit cost and reflected in the final pricing
                                                                </span>
                                                            </span>
                                                        </label>
                                                        <Field
                                                            name={`materials[${index}].discount`}
                                                            type="text"
                                                            className={`h-[42px] w-full rounded-lg border-[#DCDCD0] border px-3 py-2 ${(!values.materials[index].isAvailable || isReadOnly) ? "bg-gray-100" : "bg-white"}`}
                                                            onChange={(e) => handleFieldChange(index, 'discount', e.target.value, values, setFieldValue)}
                                                            disabled={!values.materials[index].isAvailable || isReadOnly}
                                                        />
                                                        <ErrorMessage name={`materials[${index}].discount`} component="div" className="text-red-500 text-sm" />
                                                    </div>

                                                    {/* gst */}
                                                    <div className="self-start">
                                                        <label htmlFor="" className="text-sm pb-2 font-semibold lg:hidden">GST (%)</label>
                                                        <CustomGstDropdown
                                                            options={[0, 5, 12, 18, 28]}
                                                            value={values.materials[index].gst}  // Display the current value
                                                            onChange={(value) => handleFieldChange(index, 'gst', value, values, setFieldValue)}
                                                            className="h-[42px] text-base"
                                                            disabled={!values.materials[index].isAvailable || isReadOnly}
                                                        />
                                                        <ErrorMessage name={`materials[${index}].gst`} component="div" className="text-red-500 text-base lg:text-sm h-fit" />
                                                    </div>
                                                </div>

                                                <div className="rounded-xl bg-white border border-[#EAEADE] px-3 py-2 flex items-center justify-between">
                                                    <label className="font-semibold text-sm pb-2 col-span-2 flex items-center relative">
                                                        Item Rate
                                                    </label>
                                                    <p className="text-base font-semibold text-[#303026]">{new Intl.NumberFormat('en-IN').format(values.materials[index].basePrice - (values.materials[index].basePrice * values.materials[index].discount) / 100) || 0}</p>
                                                </div>

                                                {isAdvancedTransport && <div className="col-span-2 flex flex-col">
                                                    <label className="font-semibold text-sm pb-2 col-span-2 flex items-center relative">
                                                        Transport Per Unit
                                                    </label>
                                                    <div className="col-span-2 justify-self-center flex flex-col">
                                                        <Field
                                                            name={`materials[${index}].transportRate`}
                                                            type="text"
                                                            className={`w-full rounded-lg p-2 text-sm text-right focus:ring-0 h-[42px] border-[#DCDCD0] border ${(!values.materials[index].isAvailable || isReadOnly) ? "bg-gray-100" : "bg-white"}`}
                                                            onChange={(e) => handleFieldChange(index, 'transportRate', e.target.value, values, setFieldValue)}
                                                            disabled={!values.materials[index].isAvailable || isReadOnly}
                                                        />
                                                        <ErrorMessage name={`materials[${index}].transportRate`} component="div" className="text-red-500 text-xs" />
                                                    </div>
                                                </div>}

                                                {/* <div className="flex justify-between w-full">
                                                            <label className="font-semibold text-sm pb-2 col-span-2 flex items-center relative">
                                                                Transport Cost :
                                                            </label>
                                                            {isAdvancedTransport && <p className="pr-2 break-words">{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(values.materials[index].transportCost || 0)}</p>}
                                                        </div> */}
                                                {/* delivery date */}
                                                {/* <div className="col-span-2 self-end">
                                                                            <label htmlFor="" className="text-sm pb-2 font-semibold lg:hidden">Delivery Date</label>
                                                                            <Field
                                                                                type="date"
                                                                                id={`deliveryDate-${index}`}
                                                                                name={`materials[${index}].deliveryDate`}
                                                                                className="shadow-sm block h-[40px] lg:w-full w-[150px] text-sm px-4 py-2 border border-gray-300 focus:outline-none focus:ring-sky-500 focus:ring-width-1"
                                                                                onChange={(e) => handleFieldChange(index, 'deliveryDate', e.target.value, values)} // Ensure you have this function defined
                                                                            />
                                                                            <ErrorMessage
                                                                                name={`materials[${index}].deliveryDate`}
                                                                                component="div"
                                                                                className="text-red-500 text-xs"
                                                                            />
                                                                        </div> */}

                                                <div className={`flex justify-between items-center rounded-xl border border-dashed border-[#CFCFC2] px-3 py-3 text-center col-span-1 mt-2 ${isReadOnly ? "bg-gray-50" : "bg-white"}`}>
                                                    <p className="text-sm font-semibold ">{isReadOnly ? "Attachments" : "Add Attachment"}</p>
                                                    <div className={`relative flex h-8 w-8 items-center justify-center rounded-full ${isReadOnly ? "bg-gray-100" : "bg-[#F1F4FF]"}`}>
                                                        <AttachFileIcon
                                                            className={isReadOnly ? "cursor-not-allowed text-gray-400" : "hover:cursor-pointer"}
                                                            sx={{
                                                                width: "0.7em", ml: "2px", mb: "8px",
                                                                transform: 'rotate(45deg)',
                                                                transition: 'transform 0.3s ease'
                                                            }}
                                                            onClick={() => {
                                                                if (isReadOnly) return;
                                                                setSelectedMaterialIndex(index); // Set the labor index
                                                                setOpenUploadFile(true); // Open the file upload popup
                                                            }}
                                                        />

                                                        {values.materials[index]?.attachments?.length > 0 && (
                                                            <span
                                                                className="absolute top-0 right-2 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center"
                                                                style={{ transform: 'translate(50%, -50%)' }}
                                                            >
                                                                {values.materials[index].attachments.length}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div>
                                                    <label htmlFor="" className="text-sm pb-2 font-semibold lg:hidden">Remarks</label>

                                                    <style>
                                                        {`
                                                                        /* Remove padding from the ReactQuill editor's container */
                                                                        .no-padding .ql-container {
                                                                        padding: 4px !important;
                                                                        border: none !important;
                                                                      }
                                                                       .no-padding .ql-editor {
                                                                       padding: 4px !important;
                                                                       font-size: 0.75rem !important; /* Equivalent to Tailwind's text-xs */
                                                                       line-height: 1rem; /* Optional: Adjust line height for better readability */
                                                                     }
                                                                  `}
                                                    </style>
                                                    <ReactQuill
                                                        value={values?.materials?.[index]?.remark || ''}
                                                        name={`materials[${index}].remark`}
                                                        onChange={(value) => {
                                                            if (!values.materials[index].isAvailable || isReadOnly) return;
                                                            handleFieldChange(index, 'remark', value, values, setFieldValue);

                                                            // Adjust the textarea height
                                                            // e.target.style.height = "auto"; 
                                                            // e.target.style.height = `${e.target.scrollHeight}px`; 
                                                        }}
                                                        readOnly={!values.materials[index].isAvailable || isReadOnly}
                                                        theme="snow"
                                                        className={`min-h-[72px] max-h-[120px] rounded-lg text-xs word-break whitespace-normal p-0 py-0 px-0 focus:outline-none focus:ring-0 border-[#DCDCD0] border w-full overflow-y-auto no-padding ${(!values.materials[index].isAvailable || isReadOnly) ? "bg-gray-100" : "bg-white"}`} // Set min and max height
                                                        modules={{ toolbar: false }}
                                                    // style={{ padding: "-10px" }}
                                                    /><ErrorMessage
                                                        name={`materials[${index}].remark`} component="div" className="text-red-500 text-xs" />
                                                </div>

                                                {/* amount */}
                                                <div className="w-full rounded-xl py-3 px-4 flex justify-between items-center border border-[#D8E4FF] lg:bg-white lg:border-none">
                                                    <label htmlFor="" className="text-base text-[#004491] font-semibold lg:hidden">Total (Excl. GST)</label>
                                                    <p className="text-right text-sm self-end text-[#004491] lg:text-black col-span-1">Rs. {new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(values.materials[index].totalExclGst || 0)}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                                <div className="mt-4 rounded-xl border border-[#D8E4FF] bg-[#EAF1FF] px-4 py-3 flex justify-between items-center">
                                    <p className="text-base font-semibold text-[#004491]">
                                        Sub Total
                                    </p>
                                    <p className="text-base font-semibold text-[#004491]">
                                        Rs. {new Intl.NumberFormat('en-IN', {
                                            minimumFractionDigits: 2,
                                        }).format(totalMaterialValueExclGst)}
                                    </p>
                                </div>
                            </div>
                        </MobileSectionCard>
                        <MobileSectionCard
                            number="2"
                            title="Other Charges"
                            description="Add any applicable extra costs and review the quotation totals."
                        >
                            {/* miscellaneous */}
                            {(() => {
                                const chargeLabels = {
                                    transport: "transport",
                                    mathadeCharges: "mathade",
                                    loading: "loading",
                                    unLoading: "unloading",
                                    miscCharges: "miscellaneous",
                                };

                                const absentCharges = Object.entries(rfqData?.otherCharges || {})
                                    .filter(([_, value]) => value === false)
                                    .map(([key]) => chargeLabels[key])
                                    .filter(Boolean);

                                if (absentCharges.length === 0) return null;

                                const formattedCharges =
                                    absentCharges.length === 1
                                        ? absentCharges[0]
                                        : absentCharges.slice(0, -1).join(", ") + " and " + absentCharges.slice(-1);

                                const isPlural = absentCharges.length > 1;

                                return (
                                    <div className="mb-4 rounded-xl border border-amber-200 bg-amber-50 px-3 py-3 text-xs leading-5 text-[#5E4B19]">
                                        <b>IMPORTANT NOTE:</b> Please note that if {formattedCharges} charges are applicable,
                                        {isPlural ? " they must" : " it must"} be included in the rate and applicable charges will
                                        be taken care by vendor unless mentioned in the terms otherwise.
                                    </div>
                                );
                            })()}
                            <div>
                                <div className="space-y-3">
                                    {/* Mapping miscellaneousItems instead of charges */}
                                    {visibleMiscellaneousItems.map((item, index) => (
                                        <div key={index} className="rounded-xl border border-[#E7E7DD] bg-[#FCFCFA] p-3">
                                            {/* MRP and GST inputs for mobile */}
                                            <div className="grid grid-cols-[1fr_82px] gap-3 items-end lg:hidden pb-3">
                                                <div>
                                                    <p className="text-sm font-semibold text-[#303026]">{item.label}</p>
                                                    {isAdvancedTransport && item.name === "transport" && (
                                                        <p className="text-xs font-normal text-[#9D9D9D] pb-2 lg:hidden">
                                                            Transport cost based on the per-unit material transport rate
                                                        </p>
                                                    )}
                                                    <Field
                                                        name={`miscellaneousCosts.${item.name}.mrp`}
                                                        type="text"
                                                        className={`mt-2 h-[42px] w-full rounded-lg border border-[#DCDCD0] px-3 text-sm ${isReadOnly || (isAdvancedTransport && item.name === "transport") ? "bg-gray-100" : "bg-white"}`}
                                                        placeholder="Enter MRP"
                                                        onChange={(e) => {
                                                            // Only allow changes in lumpsum mode or for non-transport fields
                                                            if (!isAdvancedTransport || item.name !== "transport") {
                                                                handleMiscellaneousChange(item.name, e.target.value, setFieldValue, values, 'mrp');
                                                            }
                                                        }}
                                                        disabled={isReadOnly || (isAdvancedTransport && item.name === "transport")}
                                                        value={
                                                            isAdvancedTransport && item.name === "transport"
                                                                ? values.materials.reduce((sum, m) => sum + (m.transportCost || 0), 0) // Auto-calculated in per-unit mode
                                                                : values.miscellaneousCosts[item.name]?.mrp || "" // Manual entry in lumpsum mode
                                                        }
                                                    />
                                                </div>
                                                <div>
                                                    <p className="text-sm font-semibold text-[#303026]">GST</p>
                                                    <CustomGstDropdown
                                                        options={[0, 5, 12, 18, 28]}
                                                        value={values.miscellaneousCosts[item.name]?.gst}
                                                        name={`miscellaneousCosts.${item.name}.gst`}
                                                        className="col-span-1 w-full h-[42px]"
                                                        onChange={(value) => handleGstChange(item.name, value, setFieldValue, values)}
                                                        disabled={isReadOnly || (isAdvancedTransport && item.name === "transport")}

                                                    />
                                                </div>
                                            </div>

                                            {/* Subtotal display */}
                                            <div className="flex justify-between lg:justify-end items-center rounded-lg py-2 px-3 bg-[#EAF1FF] border border-[#D8E4FF] lg:border-none lg:bg-white">
                                                <p className="text-[#004491] text-sm font-semibold lg:hidden">Total</p>
                                                <p className="text-[#004491] font-semibold lg:font-normal col-span-1 lg:text-black lg:text-right">
                                                    Rs. {new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0 }).format((values.miscellaneousCosts[item.name].mrp || 0))}
                                                </p>
                                            </div>
                                        </div>
                                    ))}

                                    {/* Total amount for mobile */}
                                    <div className="lg:hidden">
                                        <div className="flex px-4 py-2 lg:p-0 justify-between items-center rounded-lg border lg:border-none border-[#D6E9E4] lg:bg-white">
                                            <p className="lg:font-bold text-[#007366] lg:text-black font-semibold">Sub Total</p>
                                            <p className="text-[#007366] font-semibold text-end lg:font-normal lg:text-black w-fit min-w-[164px] lg:px-4 py-2">
                                                Rs. {new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0 }).format((overallTotalExclGST || 0))}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="lg:hidden">
                                        <div className="flex px-4 py-2 lg:p-0 justify-between items-center rounded-lg border lg:border-none border-[#D6E9E4] lg:bg-white">
                                            <p className="lg:font-bold text-[#007366] lg:text-black font-semibold">GST Total</p>
                                            <p className="text-[#007366] font-semibold text-end lg:font-normal lg:text-black w-fit min-w-[164px] lg:px-4 py-2">
                                                Rs. {new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format((overallTotal - overallTotalExclGST).toFixed(2))}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="lg:hidden">
                                        <div className="flex px-4 py-3 lg:p-0 justify-between items-center rounded-xl border lg:border-none border-[#B9DDD5] bg-[#E0F0EE] lg:bg-white">
                                            <p className="lg:font-bold text-[#007366] lg:text-black font-semibold">Total Quotation Value (inc. GST)</p>
                                            <p className="bg-[#E0F0EE] text-[#007366] font-semibold text-end lg:font-normal lg:text-black w-fit min-w-[164px] lg:px-4 py-2">
                                                Rs. {new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0 }).format((overallTotal || 0))}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </MobileSectionCard>

                        {/* {currentStep === 3 && (
                            <div>
                                <div className="mb-8 lg:mb-[40px]">
                                    <h3 className="text-sm font-semibold text-[#3B3B3B] lg:hidden">Supporting Documents</h3>
                                    <p className="text-xs font-normal text-[#9D9D9D] pb-4 lg:hidden">Below are the supporting documents uploaded by the buyer. Please review them.</p>
                                    {attachmentsData.length > 0 ? (
                                        <>
                                            <div className="lg:grid lg:grid-cols-4 lg:gap-4 space-y-4 lg:space-y-0 lg:mt-4">
                                                {attachmentsData.map((doc, index) => (
                                                    <div key={index} className="flex justify-between items-center">
                                                        <div className="flex w-fit items-center justify-center border border-[#8E8E85] rounded-full py-2 px-2 space-x-2 text-[#434343]">
                                                            <img src={`/assets/icons/${doc.Path}.png`} alt={doc.Path} className="h-5 w-5" />
                                                            <a
                                                                href={doc.Content}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                download={doc.Name}
                                                                className="text-xs text-[#434343] hover:underline"
                                                            >
                                                                {doc.Name}
                                                            </a>
                                                        </div>
                                                        <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/download_solid.svg" alt="" className="lg:hidden" />
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    ) :

                                        <>
                                            <div className="text-gray-400 italic">No Supporting Documents provided by Buyer, move to next step </div>
                                        </>

                                    }
                                </div>
                            </div>
                        )} */}
                        <MobileSectionCard
                            number="3"
                            title="Additional Information"
                            description="Confirm payment terms and add any remarks for the client."
                        >
                            {/* Additional Information Section */}
                            <div>
                                {/* <p className="text-sm font-normal lg:mx-0 py-4 lg:hidden">Below are our payment Terms. </p> */}

                                <div className="lg:flex justify-between items-center">
                                    {/* <div>
                                            <div className="bg-[#F6F6F4] py-2 px-4 lg:w-[390px] lg:h-[182px] lg:mx-0 " >
                                                <p
                                                    className="w-full border-none p-0 bg-[#F6F6F4] text-[#3D3D3D] text-sm"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            rfqData?.paymentTerms.length > 210
                                                                ? rfqData.paymentTerms.slice(0, 210) + "..."
                                                                : rfqData.paymentTerms,
                                                    }}
                                                ></p>

                                                {rfqData?.paymentTerms.length > 210 && <button
                                                    onClick={togglePopup}
                                                    type="button"
                                                    className="text-[#8E8E85] text-sm italic underline pt-2"
                                                >
                                                    Read More
                                                </button>}

                                                {isPopupOpen && (
                                                    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">

                                                        <div className="bg-white border-[25px] mx-4 border-white rounded-lg shadow-lg max-w-md w-full h-[320px] relative" style={{ overflowY: 'scroll', msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
                                                            <style>
                                                            </style>
                                                            <div className="sticky top-0 bg-white pb-4">
                                                                <button
                                                                    onClick={togglePopup}
                                                                    className="absolute top-0 right-0 text-gray-400 hover:text-gray-600"
                                                                >
                                                                    <svg className="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                                                    </svg>
                                                                </button>
                                                                <h2 className="text-lg font-semibold">Payment Details</h2>
                                                                <hr />
                                                            </div>
                                                            <p className="text-sm text-[#3D3D3D] overflow-y-auto " dangerouslySetInnerHTML={{ __html: rfqData?.paymentTerms }}>
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div> */}

                                    <div className="lg:hidden justify-between items-center rounded-xl border border-[#E7E7DD] bg-[#FCFCFA] p-4">
                                        <p className="text-sm font-semibold text-[#303026]">
                                            Do you agree with payment terms?
                                        </p>
                                        <div className="grid grid-cols-2 gap-3 mt-3">
                                            <label className={`inline-flex items-center rounded-lg border px-3 py-2 text-sm ${!isCounterOfferSelected(values.agreedToPaymentTerms) ? "border-[#1E1E08] bg-[#F2F2EA]" : "border-[#E0E0D6] bg-white"}`}>
                                                <input type="radio"
                                                    name="paymentTerms"
                                                    checked={!isCounterOfferSelected(values.agreedToPaymentTerms)}
                                                    onChange={() => {
                                                        setFieldValue('agreedToPaymentTerms', true);
                                                        setFieldValue('counterPaymentTerms', '');
                                                        setIsCounterTerm(false); // Update counter term
                                                    }}
                                                    className="form-radio disabled:cursor-not-allowed"
                                                    disabled={isReadOnly} />
                                                <span className="ml-2">Yes</span>
                                            </label>
                                            <label className={`inline-flex items-center rounded-lg border px-3 py-2 text-sm ${isCounterOfferSelected(values.agreedToPaymentTerms) ? "border-[#1E1E08] bg-[#F2F2EA]" : "border-[#E0E0D6] bg-white"}`}>
                                                <input type="radio"
                                                    name="paymentTerms"
                                                    checked={isCounterOfferSelected(values.agreedToPaymentTerms)}
                                                    onChange={() => {
                                                        setFieldValue('agreedToPaymentTerms', false);
                                                        setIsCounterTerm(true); // Update counter term
                                                    }}
                                                    className="form-radio disabled:cursor-not-allowed"
                                                    disabled={isReadOnly} />
                                                <span className="ml-2">Counter Offer</span>
                                            </label>
                                        </div>
                                    </div>
                                    {isCounterOfferSelected(values.agreedToPaymentTerms) && <div className="mt-4">
                                        <p className="text-sm font-semibold text-[#4F4F42]">Counter Payment Terms</p>
                                        <Field
                                            as="textarea"
                                            name="counterPaymentTerms"
                                            className={`lg:w-[390px] w-full h-[144px] my-2 rounded-xl border border-[#DCDCD0] px-3 py-2 text-sm placeholder:italic ${isReadOnly ? "bg-gray-100" : "bg-white"}`}
                                            placeholder="Please write your counter payment terms Rich Text "
                                            disabled={isReadOnly}
                                        />
                                    </div>}
                                </div>
                                <div className="lg:flex mt-4 lg:mt-8 lg:mx-0">
                                    <p className="text-sm font-semibold text-[#434343] mb-2 lg:mb-0">Make/Brand & Remarks for Client</p>
                                    <Field
                                        as="textarea"
                                        name="notes"
                                        placeholder="Mention Make/Brand & Notes "
                                        className={`rounded-xl border-[#CDCDB8] w-full lg:ml-5 lg:w-full h-[125px] px-3 py-2 text-sm placeholder:italic placeholder-[#8C8C8C] ${isReadOnly ? "bg-gray-100" : "bg-white"}`}
                                        disabled={isReadOnly}
                                    />
                                </div>
                                <div className="mt-4">
                                    <p className="text-sm font-semibold text-[#434343] mb-2">
                                        Delivery Date <span className="text-xs font-normal text-[#8C8C8C]">(Optional)</span>
                                    </p>
                                    <Field
                                        type="date"
                                        name="deliveryDate"
                                        className={`w-full rounded-xl border border-[#CDCDB8] px-3 py-2 text-sm focus:ring-0 ${isReadOnly ? "bg-gray-100" : "bg-white"}`}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        </MobileSectionCard>

                        {/* Upload Supporting Documents */}
                        <MobileSectionCard
                            number="4"
                            title="Upload Supporting Documents"
                            description="Attach proposal files or supporting documents if required."
                        >
                            <div>

                                {attachmentsSkeleton.length > 0 && (
                                    <p className="mb-3 rounded-lg bg-blue-50 px-3 py-2 text-xs leading-5 text-blue-800">
                                        Your file is being scanned for upload, be patient and continue to fill
                                        the rest of the form.
                                    </p>
                                )}

                                <div className="mb-3">
                                    {/* Display the selected file names */}
                                    <ul className="flex flex-wrap gap-2">
                                        {selectedFilesBase.map((file, index) => (
                                            <a
                                                href={file.Content}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="border border-[#D9D9CF] bg-[#FCFCFA] px-3 py-1 rounded-full flex items-center"
                                                key={file.Name}
                                            >
                                                <span className="text-sm overflow-hidden whitespace-nowrap w-36 truncate">
                                                    {file.Name}
                                                </span>
                                                {!isReadOnly && (
                                                    <span
                                                        className="ml-1 cursor-pointer"
                                                        onClick={(event) => handleDeleteSelectedFile(file.Name, event, setSelectedFilesBase, setSelectedFilesTotalSize)}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="18"
                                                            height="18"
                                                            viewBox="0 0 48 48"
                                                        >
                                                            <circle cx="24" cy="24" r="22" fill="gray" />
                                                            <line
                                                                x1="15"
                                                                y1="15"
                                                                x2="33"
                                                                y2="33"
                                                                stroke="white"
                                                                strokeWidth="2"
                                                            />
                                                            <line
                                                                x1="33"
                                                                y1="15"
                                                                x2="15"
                                                                y2="33"
                                                                stroke="white"
                                                                strokeWidth="2"
                                                            />
                                                        </svg>
                                                    </span>
                                                )}
                                            </a>
                                        ))}

                                        {/* Skeleton loaders for files being processed */}
                                        {attachmentsSkeleton.map((_, index) => (
                                            <Skeleton
                                                key={index}
                                                variant="rounded"
                                                sx={{ borderRadius: "20px", margin: "4px" }}
                                                width={150}
                                                height={32}
                                            />
                                        ))}
                                    </ul>
                                    {selectedFilesBase.length === 0 && attachmentsSkeleton.length === 0 && (
                                        <p className="rounded-lg border border-dashed border-[#DCDCD0] bg-[#FCFCFA] px-4 py-3 text-sm text-[#7A7A68]">
                                            No supporting documents uploaded.
                                        </p>
                                    )}
                                </div>

                                <div>
                                    {attachmentsUploadsErrors && (
                                        <div className="mt-3">
                                            <p className="rounded-lg bg-red-50 px-3 py-2 text-red-600 font-semibold text-sm">
                                                {attachmentsUploadsErrors}
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* Error handling for file size */}
                                <div
                                    className={`fixed bottom-0 left-2  p-4 ${openFilesSizeError ? "block" : "hidden"
                                        }`}
                                >
                                    <div className="bg-orange-100 w-[calc(100vw-1rem)] max-w-[440px] flex items-center justify-between px-4 py-1 text-yellow-900 rounded-lg shadow-md p-4">
                                        <p>Total size of attachments is not more than 10 MB</p>
                                        <button
                                            onClick={handleCloseFileSizeError}
                                            className="px-4 py-2 focus:outline-none"
                                        >
                                            <svg
                                                className="h-6 w-6"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M6 18L18 6M6 6l12 12"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>


                                {/* drag and drop file */}
                                {!isReadOnly && <div className="flex items-center justify-center h-[175px] lg:h-[301px] rounded-2xl bg-[#F6FAFF] lg:bg-white border-2 border-dashed border-[#8EA8FF] lg:border-[#7D7D7D] relative">
                                    <div className="lg:hidden flex flex-col items-center justify-center">
                                        <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/create_rfq_upload.svg" alt="" className="mx-auto" />
                                        <p className="text-center mt-4 text-sm font-semibold text-[#303026]">Upload your files here</p>
                                        <p className="mt-1 text-center text-xs text-[#7A7A68]">PDF, image, Excel, CSV or DWG files</p>
                                        <label htmlFor="file" className="mt-2 text-[#1D28FA] underline text-center cursor-pointer">
                                            Browse
                                        </label>
                                    </div>
                                    <input
                                        type="file"
                                        accept=".pdf,.jpg,.jpeg,.png,.gif,.xlsx,.xls,.csv,.dwg" // Specify allowed file types
                                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                        onClick={handleFileUploadClick}
                                        onChange={(event) =>
                                            handleFileUpload(
                                                event,
                                                selectedFilesTotalSize,
                                                setAttachmentsSkeleton,
                                                setSelectedFilesBase,
                                                setSelectedFilesTotalSize,
                                                setOpenFilesSizeError,
                                                setAttachmentsUploadsErrors
                                            )
                                        }
                                        multiple // Allow multiple files to be selected
                                    />

                                </div>}
                            </div>
                        </MobileSectionCard>

                        {/* {currentStep === 5 &&

                            (<div className="text-gray-400 italic">No Supporting Documents provided by Buyer, move to next step </div>)

                        } */}
                    </div>
                </div>


            </div>
        </div>
    )
}

export default MaterialMobileQuotatoinForm
